/**
 * Sub-unit selector strip rendered above the Flashing panel. The pencil edit
 * icon appears only on the active pill; clicking it opens an inline edit
 * panel (rendered by the parent) where both rename and delete live. The
 * dotted-circle "+" button at the end of the row appends another unit.
 * Visual pattern mirrors the driver tabs on the Runs page.
 *
 * Plain-button impl instead of MUI <Tabs> — Tabs with variant="standard" was
 * occasionally dropping the first tab on first render after data load.
 */

import React from 'react';
import { Tooltip } from '@mui/material';
import { MdOutlineModeEditOutline, MdAdd } from 'react-icons/md';
import '../styles/UnitTabsBar.scss';

const UnitTabsBar = ({
  units = [],
  selectedUnitId,
  onSelect,
  onEdit,
  onAddUnit,
  readOnly = false
}) => {
  if (!units.length) return null;

  return (
    <div className="unit-tabs-bar">
      <div className="unit-tabs-bar__list">
        {units.map((u) => {
          const isSelected = u._id === selectedUnitId;
          return (
            <div
              key={u._id}
              className={`unit-tabs-bar__pill${isSelected ? ' is-selected' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => onSelect && onSelect(u._id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelect && onSelect(u._id);
                }
              }}
              title={u.unit_order_number}
            >
              <span className="unit-tabs-bar__pill-label">{u.unit_order_number}</span>
              {isSelected && !readOnly && onEdit && (
                <Tooltip title={`Edit ${u.unit_order_number}`}>
                  <button
                    type="button"
                    className="unit-tabs-bar__pill-edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEdit(u);
                    }}
                    aria-label={`edit-${u.unit_id}`}
                  >
                    <MdOutlineModeEditOutline size={16} />
                  </button>
                </Tooltip>
              )}
            </div>
          );
        })}

        {!readOnly && onAddUnit && (
          <Tooltip title="Add another unit">
            <button
              type="button"
              className="unit-tabs-bar__add-btn"
              onClick={onAddUnit}
              aria-label="add-unit"
            >
              <MdAdd size={26} />
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default UnitTabsBar;
